import { css } from "@linaria/core";

export const svgCls = css`
  pointer-events: none;
`;
